const RECENT_KEY = "ems_recent_apps";
const PINNED_KEY = "ems_pinned_apps";
const MAX_RECENT = 5;

function safeParse(json, fallback) {
  try {
    const v = JSON.parse(json);
    return Array.isArray(v) ? v : fallback;
  } catch {
    return fallback;
  }
}

export function getPinnedAppIds() {
  return safeParse(localStorage.getItem(PINNED_KEY), []);
}

export function togglePinnedApp(appId) {
  const cur = getPinnedAppIds();
  const next = cur.includes(appId) ? cur.filter((id) => id !== appId) : [...cur, appId];
  localStorage.setItem(PINNED_KEY, JSON.stringify(next));
  return next;
}

export function isPinned(appId) {
  return getPinnedAppIds().includes(appId);
}

export function recordRecentApp(appId) {
  const prev = safeParse(localStorage.getItem(RECENT_KEY), []);
  const next = [appId, ...prev.filter((id) => id !== appId)].slice(0, MAX_RECENT);
  localStorage.setItem(RECENT_KEY, JSON.stringify(next));
}

export function getRecentAppIds() {
  return safeParse(localStorage.getItem(RECENT_KEY), []);
}
